import Employee from "./views/pages/Employee";
import EmployeeFormPage from "./views/pages/employees/EmployeeFormPage";
import TeamPermissions from "./views/pages/employees/TeamPermissions";

import UniversalShipments from "./views/pages/UniversalShipments";

//PRODUCTS
import AddProduct from "./views/pages/products/AddProduct";
import ProductListing from "./views/pages/products/ProductListing";
import ProductDetail from "./views/pages/products/ProductDetail";
import TaskTracker from "./views/pages/task-tracker/TaskTracker";

// ALERTS
import AlertsInbox from "./views/pages/alerts/AlertsInbox";
import AlertDetailPage from "./views/pages/alerts/AlertDetailPage";

//ORDERS
import Orders from "./views/pages/orders/Orders";
import StockCheckRequests from "./views/pages/orders/StockCheckRequests";
import ProjectRequests from "./views/pages/orders/ProjectRequests";
import PaymentLinksListing from "./views/pages/orders/PaymentLinksListing";

// TASK TRACKER
import AddEditTask from "./views/pages/task-tracker/AddEditTask";
import Vendor from "./views/pages/vendors/Vendor";
import AddEditVendor from "./views/pages/vendors/AddEditVendor";
import ProductVariantsList from "./views/pages/products/ProductVariantsList";
import PodCatalogLiteDetail from "./views/pages/products/PodCatalogLiteDetail";
import CategoryListing from "./views/pages/categories/CategoryListing";
import CategoryDetail from "./views/pages/categories/CategoryDetail";
import CatalogOptionsListing from "./views/pages/catalog-options/CatalogOptionsListing";
import CatalogOptionDetail from "./views/pages/catalog-options/CatalogOptionDetail";
import VendorRequestListing from "./views/pages/vendors/VendorRequest";

// INVENTORY
import CouponsListing from "./views/pages/inventory/CouponsListing";
import CustomerListing from "./views/pages/customers/CustomerListing";
import UserListing from "./views/pages/users/UserListing";
import AddCustomer from "./views/pages/customers/AddCustomer";
import AddUser from "../../views/pages/users/AddUser";
import AddOrder from "./views/pages/orders/AddOrder";
import AddressListing from "./views/pages/address/AddressListing";
import AddEditAddress from "./views/components/address/AddEditAddress";
import CreateInvoice from "./views/pages/orders/invoice/CreateInvoice";
import ProjectManagement from "./views/pages/projects/ProjectManagement/ProjectManagementListing";
import ProjectsLayout from "./views/pages/projects/ProjectsLayout";

import Dashboard from "./views/pages/dashboard/Dashboard";
import PartnerAnalyticsDashboard from "./views/pages/dashboard/PartnerAnalyticsDashboard";
import OpsAnalyticsDashboard from "./views/pages/dashboard/OpsAnalyticsDashboard";
import SourcingOpsDetails from "./views/pages/projects/sourcing-ops-details/SourcingOpsDetails";
import InventoryListing from "./views/pages/inventory/InventoryListing";

import InventorySwagpackDetails from "./views/pages/inventory/InventorySwagpackDetails";
import InventorySwagpackVariant from "./views/pages/inventory/InventorySwagpackVariant";
import InventoryCountImportLogs from "./views/pages/inventory/InventoryCountImportLogs";
import InventoryInboundImportLogs from "./views/pages/inventory/InventoryInboundImportLogs";
import DataReport from "./views/pages/report/DataReport";
import VendorsDashboard from "./views/pages/dashboard/VendorsDashboard";
import InventoryOpsDetails from "./views/pages/projects/inventory-ops-details/InventoryOpsDetails";
import PackagingOpsMedia from "./views/pages/projects/packaging-ops-media/PackagingOpsMedia";
import CreatePack from "./views/pages/projects/packaging-ops/CreatePack";
import OpsSourcingDashboard from "./views/pages/dashboard/OpsSourcingDashboard";
import SalesAnalyticsDashboard from "./views/pages/dashboard/SalesAnalyticsDashboard";
import OpsSync from "./views/pages/projects/ops-sync/OpsSync";
import ProposalDashboard from "./views/pages/dashboard/ProposalDashboard";
import FinanceAnalyticsDashboard from "./views/pages/dashboard/FinanceAnalyticsDashboard";
import QCAnalyticsDashboard from "./views/pages/dashboard/QCAnalyticsDashboard";
import MockupsAnalyticsDashboard from "./views/pages/dashboard/MockupsAnalyticsDashboard";
import UrgentSourcingDashboard from "./views/pages/dashboard/UrgentSourcingDashboard";
import StockCheckAnalyticsDashboard from "./views/pages/dashboard/StockCheckAnalyticsDashboard";
import LogisticsAnalyticsDashboard from "./views/pages/dashboard/LogisticsAnalyticsDashboard";
import MockupGenerator from "./views/pages/mockup-generator/MockupGenerator";
import NPSAnalyticsDashboard from "./views/pages/dashboard/NPSAnalyticsDashboard";
import CustomerExperienceAnalyticsDashboard from "./views/pages/dashboard/CustomerExperienceAnalyticsDashboard";
import OnelinkRequestsListing from "./views/pages/orders/OnelinkRequestsListing";
import DispatchOps from "./views/pages/projects/dispatch-ops/DispatchOps";
import Swagstore from "./views/pages/swagstore/Swagstore";
import StorePreviewPage from "./views/pages/swagstore/StorePreviewPage";
import StoreListing from "./views/pages/swagstore/StoreListing";
import SwagstoreWalletListing from "./views/pages/swagstore-wallet/SwagstoreWalletListing";
import SwagstorePurchaseTransactionsListing from "./views/pages/swagstore/SwagstorePurchaseTransactionsListing";
import UnpaidSamplesAnalyticsDashboard from "./views/pages/dashboard/UnpaidSamplesAnalyticsDashboard";
import PurchaseRequest from "./views/pages/purchase-request/PurchaseRequest";
import PurchaseRequestDetail from "./views/pages/purchase-request/PurchaseRequestDetail";
import UnpaidSampleReturnListing from "./views/pages/projects/unpaid-sample/UnpaidSampleReturnListing";
import UrgentSourcingRequestListing from "./views/pages/urgent-sourcing/UrgentSourcingRequestListing";
import OpsSyncAnalyticsDashboard from "./views/pages/dashboard/OpsSyncAnalyticsDashboard";
import UrgentSourcingProductsListing from "./views/pages/urgent-sourcing/UrgentSourcingProductsListing";
import SwageazyInventoryListing from "./views/pages/projects/swageazy-Inventory/SwageazyInventory";
import InvoicesListing from "./views/pages/invoices/InvoicesListing";
import LeadsListing from "./views/pages/leads/LeadsListing";
import WaitlistListing from "./views/pages/swayy/WaitlistListing";
import VouchersListing from "./views/pages/vouchers/VouchersListing";
import SendVouchersEmailer from "./views/pages/vouchers/SendVouchersEmailer";
import VoucherEmailersListing from "./views/pages/emailers/VoucherEmailersListing";
import CreateProperty from "./views/pages/property/CreateProperty";
import PropertyListing from "./views/pages/property/PropertyListing";
import PurchaseOrderInvoicesListing from "./views/pages/invoices/VendorInvoicesListing";
import VouchersRequests from "./views/pages/vouchers/VouchersRequests";
import VendorsPOReportView from "./views/pages/vendors/VendorsPOReportView";
import CampaignList from "./views/pages/campaigns/CampaignList";
import CampaignShipmentGap from "./views/pages/campaigns/CampaignShipmentGap";
import MockupConfig from "./views/pages/mockup-generator/MockupConfig";
import HrmsList from "./views/pages/hrms/HrmsList";
import HrmsGetKnitSync from "./views/pages/hrms/HrmsGetKnitSync";
import StorageCostListing from "./views/pages/storage-cost/StorageCostListing";
import StorageCostDetailListing from "./views/pages/storage-cost/StorageCostDetailsListing";
import ProjectLayout from "./v1/projects/project-layout.view";
import LeadAnalyticsDashboard from "./views/pages/dashboard/LeadAnalyticsDashboard";
import AccountManagementDashboard from "./views/pages/dashboard/AccountManagementDashboard";
import OrderTrackingAnalyticsDashboard from "./views/pages/dashboard/OrderTrackingAnalyticsDashboard";
import NewOperationsDashboard from "./views/pages/dashboard/NewOperationsDashboard";
import RedemptionDashboard from "./views/pages/dashboard/RedemptionDashboard";
import DailyTasksDashboard from "./views/pages/dashboard/DailyTasksDashboard";
import StockIssueRequestsListing from "./views/pages/stock-issue-requests/StockIssueRequestsListing";
import StockIssueRequestDetail from "./views/pages/stock-issue-requests/StockIssueRequestDetail";
import PodOrderList from "./views/pages/pod-orders/PodAllocatedOrderList";
import AddPodOrder from "./views/pages/pod-orders/AddPodOrder";

const routes = [
  { path: "/", exact: true, element: Dashboard },
  { path: "/partners", exact: true, element: PartnerAnalyticsDashboard },
  { path: "/operations", exact: true, element: OpsAnalyticsDashboard },
  { path: "/operations/tats", exact: true, element: NewOperationsDashboard },
  {
    path: "/operations/daily-tasks",
    exact: true,
    element: DailyTasksDashboard,
  },
  {
    path: "/operations/ops-sync",
    exact: true,
    element: OpsSyncAnalyticsDashboard,
  },
  {
    path: "/operations/urgent-sourcing",
    exact: true,
    element: UrgentSourcingDashboard,
  },
  {
    path: "/operations/stock-check",
    exact: true,
    element: StockCheckAnalyticsDashboard,
  },
  { path: "/operations/sourcing", exact: true, element: OpsSourcingDashboard },
  { path: "/operations/vendors", exact: true, element: VendorsDashboard },
  { path: "/operations/qc", exact: true, element: QCAnalyticsDashboard },
  {
    path: "/operations/mockups",
    exact: true,
    element: MockupsAnalyticsDashboard,
  },
  {
    path: "/operations/order-tracking",
    exact: true,
    element: OrderTrackingAnalyticsDashboard,
  },
  { path: "/sales", exact: true, element: SalesAnalyticsDashboard },
  {
    path: "/sales/lead-analytics",
    exact: true,
    element: LeadAnalyticsDashboard,
  },
  { path: "/sales/proposals", exact: true, element: ProposalDashboard },
  {
    path: "/sales/unpaid-samples",
    exact: true,
    element: UnpaidSamplesAnalyticsDashboard,
  },
  {
    path: "/sales/account-management",
    exact: true,
    element: AccountManagementDashboard,
  },
  {
    path: "/inventory/storage-cost-details",
    exact: true,
    element: StorageCostListing,
  },
  {
    path: "/inventory/storage-cost-details/:id",
    exact: true,
    element: StorageCostDetailListing,
  },
  {
    path: "/finance-dashboard",
    exact: true,
    element: FinanceAnalyticsDashboard,
  },
  {
    path: "/logistics-dashboard",
    exact: true,
    element: LogisticsAnalyticsDashboard,
  },
  {
    path: "/nps-dashboard",
    exact: true,
    element: NPSAnalyticsDashboard,
  },
  {
    path: "/redemption-dashboard",
    exact: true,
    element: RedemptionDashboard,
  },
  {
    path: "/customer-experience-dashboard",
    exact: true,
    element: CustomerExperienceAnalyticsDashboard,
  },
  { path: "/operations/vendors", exact: true, element: VendorsDashboard },
  { path: "/shipments", exact: true, element: UniversalShipments },
  { path: "/inventory/shipments", exact: true, element: UniversalShipments },
  { path: "/products/listing", exact: true, element: ProductListing },
  { path: "/products/new", exact: true, element: ProductDetail },
  { path: "/products/add-edit-product", exact: true, element: AddProduct },
  {
    path: "/products/pod-catalog/:productId",
    exact: true,
    element: PodCatalogLiteDetail,
  },
  {
    path: "/products/add-edit-product/variants",
    exact: true,
    element: ProductVariantsList,
  },
  { path: "/products/:id", exact: true, element: ProductDetail },
  { path: "/categories/listing", exact: true, element: CategoryListing },
  { path: "/categories/:id", exact: true, element: CategoryDetail },
  {
    path: "/catalog-options/listing",
    exact: true,
    element: CatalogOptionsListing,
  },
  { path: "/catalog-options/:id", exact: true, element: CatalogOptionDetail },
  { path: "/inventory/listing", exact: true, element: InventoryListing },
  {
    path: "/inventory/count-import-logs",
    exact: true,
    element: InventoryCountImportLogs,
  },
  {
    path: "/inventory/inbound-import-logs",
    exact: true,
    element: InventoryInboundImportLogs,
  },
  {
    path: "/inventory/:id/packs",
    exact: true,
    element: InventorySwagpackDetails,
  },
  {
    path: "/inventory/packs/:id/variants",
    exact: true,
    element: InventorySwagpackVariant,
  },

  { path: "/alerts", exact: true, element: AlertsInbox },
  { path: "/alerts/:id", exact: true, element: AlertDetailPage },
  { path: "/task-tracker/listing", exact: true, element: TaskTracker },
  { path: "/task-tracker/add-edit-task", exact: true, element: AddEditTask },
  { path: "/employee", exact: true, element: Employee },
  { path: "/employee/add", exact: true, element: EmployeeFormPage },
  { path: "/employee/:employeeId", exact: true, element: EmployeeFormPage },
  {
    path: "/employee/team-permissions",
    exact: true,
    element: TeamPermissions,
  },
  { path: "/orders/listing", exact: true, element: Orders },
  { path: "/orders/coupons", exact: true, element: CouponsListing },
  {
    path: "/orders/onelink-requests",
    exact: true,
    element: OnelinkRequestsListing,
  },
  { path: "/customers/listing", exact: true, element: CustomerListing },
  { path: "/customers/add-edit-customer", exact: true, element: AddCustomer },
  { path: "/users/listing", exact: true, element: UserListing },
  { path: "/users/add-edit-user", exact: true, element: AddUser },
  {
    path: "/orders/stock-check-requests",
    exact: true,
    element: StockCheckRequests,
  },
  {
    path: "/orders/project-requests",
    exact: true,
    element: ProjectRequests,
  },
  {
    path: "/orders/payment-links",
    exact: true,
    element: PaymentLinksListing,
  },
  {
    path: "/orders/add-orders",
    exact: true,
    element: AddOrder,
  },
  {
    path: "/pod-orders/allocated-orders/listing",
    exact: true,
    element: PodOrderList,
  },
  {
    path: "/pod-orders/add",
    exact: true,
    element: AddPodOrder,
  },
  {
    path: "/invoices/order-invoices",
    exact: true,
    element: InvoicesListing,
  },

  {
    path: "/invoices/vendor-invoices",
    exact: true,
    element: PurchaseOrderInvoicesListing,
  },
  {
    path: "/vouchers",
    exact: true,
    element: VouchersListing,
  },
  {
    path: "/vouchers/requests",
    exact: true,
    element: VouchersRequests,
  },
  {
    path: "/emailers/vouchers",
    exact: true,
    element: VoucherEmailersListing,
  },
  {
    path: "/emailers/send-vouchers",
    exact: true,
    element: SendVouchersEmailer,
  },
  {
    path: "/vendors/listing",
    exact: true,
    element: Vendor,
  },
  {
    path: "/vendors/requests",
    exact: true,
    element: VendorRequestListing,
  },
  {
    path: "/vendors/add-edit-vendor",
    exact: true,
    element: AddEditVendor,
  },
  {
    path: "/vendors/po-report",
    exact: true,
    element: VendorsPOReportView,
  },
  {
    path: "/order/invoice/:order-id",
    exact: true,
    element: CreateInvoice,
  },
  {
    path: "project-management/listing",
    exact: true,
    element: ProjectManagement,
  },
  {
    path: "projects/:project-id",
    exact: true,
    element: ProjectsLayout,
  },
  {
    path: "v1/project/:project-id",
    exact: true,
    element: ProjectLayout,
  },
  { path: "/address/listing", exact: true, element: AddressListing },
  { path: "/address/add-edit-address", exact: true, element: AddEditAddress },
  {
    path: "/projects/sourcing-ops-details",
    exact: true,
    element: SourcingOpsDetails,
  },
  {
    path: "/projects/inventory-ops-details",
    exact: true,
    element: InventoryOpsDetails,
  },
  {
    path: "/projects/packaging-ops-media",
    exact: true,
    element: PackagingOpsMedia,
  },
  {
    path: "/projects/create-pack",
    exact: true,
    element: CreatePack,
  },
  { path: "/report/data", exact: true, element: DataReport },
  {
    path: "/projects/sourcing-ops-details",
    exact: true,
    element: SourcingOpsDetails,
  },
  {
    path: "/projects/dispatch-ops",
    exact: true,
    element: DispatchOps,
  },
  { path: "/report/data", exact: true, element: DataReport },
  {
    path: "/project-management/ops-sync",
    exact: true,
    element: OpsSync,
  },
  {
    path: "/swagstore/listing",
    exact: true,
    element: StoreListing,
  },
  {
    path: "/swagstore/create-store",
    exact: true,
    element: Swagstore,
  },
  {
    path: "/swagstore/preview",
    exact: true,
    element: StorePreviewPage,
  },
  {
    path: "/swagstore/wallet",
    exact: true,
    element: SwagstoreWalletListing,
  },
  {
    path: "/swagstore/purchase-transactions",
    exact: true,
    element: SwagstorePurchaseTransactionsListing,
  },
  {
    path: "/mockup-generator",
    exact: true,
    element: MockupGenerator,
  },
  {
    path: "/mockup-generator/mockup-config",
    exact: true,
    element: MockupConfig,
  },
  {
    path: "/purchase/requests/listing",
    exact: true,
    element: PurchaseRequest,
  },
  {
    path: "/purchase/requests/details",
    exact: true,
    element: PurchaseRequestDetail,
  },
  {
    path: "/project-management/unpaid-samples",
    exact: true,
    element: UnpaidSampleReturnListing,
  },
  {
    path: "/urgent-sourcing/requests",
    exact: true,
    element: UrgentSourcingRequestListing,
  },
  {
    path: "/urgent-sourcing/products",
    exact: true,
    element: UrgentSourcingProductsListing,
  },
  {
    path: "/swageazy-inventory",
    exact: true,
    element: SwageazyInventoryListing,
  },
  {
    path: "orders/stock-issue-request",
    exact: true,
    element: StockIssueRequestsListing,
  },
  {
    path: "orders/stock-issue-request/:id",
    exact: true,
    element: StockIssueRequestDetail,
  },
  {
    path: "/leads",
    exact: true,
    element: LeadsListing,
  },
  {
    path: "/swayy/waitlist",
    exact: true,
    element: WaitlistListing,
  },
  {
    path: "/property",
    exact: true,
    element: PropertyListing,
  },
  {
    path: "/property/create",
    exact: true,
    element: CreateProperty,
  },
  {
    path: "/property/edit/:id",
    exact: true,
    element: CreateProperty,
  },
  {
    path: "/campaigns/listing",
    exact: true,
    element: CampaignList,
  },
  {
    path: "/campaigns/eligible-employees",
    exact: true,
    element: CampaignShipmentGap,
  },
  {
    path: "/hrms/listing",
    exact: true,
    element: HrmsList,
  },
  {
    path: "/hrms/getknit-sync",
    exact: true,
    element: HrmsGetKnitSync,
  },
];

export default routes;
